import styled from 'styled-components';

import { breakpoints, SkeletonElement } from '@notino/react-styleguide-v20';

export const AnimatedSkeletonItemWithMargin = styled(SkeletonElement)`
  margin-right: 0.5rem;

  @media (min-width: ${breakpoints.md}) {
    margin-right: 1.5rem;
  }
`;

export const StyledCircle = styled(AnimatedSkeletonItemWithMargin)`
  border-radius: 50%;
`;

export const StyledBar = styled(AnimatedSkeletonItemWithMargin)`
  width: 1.5rem;
  height: 0.125rem;

  @media (min-width: ${breakpoints.md}) {
    width: 7rem;
    height: 1rem;
  }
`;

export const StyledMobileTitle = styled(SkeletonElement)`
  margin-top: 1.5rem;
  display: block;

  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;
